import { VStack, StackProps } from "@chakra-ui/react";
import React from "react";

// Vstack that doesn't get too big for a modal
export const ModalContent = (props: StackProps) => (
  <VStack id="ModalContent" overflowY="auto" w="100%" maxH="60vh" {...props} />
);
